import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthLayout from "../../../../layout/AuthLayout";
import { useRegisterStudent } from "../../../../hooks/api/Students/Auth/useRegisterStudent";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import Button from "../../../../components/Button";
import { Eye, EyeOff } from "lucide-react";
import { motion } from "framer-motion";
import clsx from "clsx";
import StudentSignUpForm from "./StudentSignUpForm";
import TutorSignUpForm from "./TutorSignUpForm";
import TutorSignUp from "../../../Tutors/Auth/SignUp/TutorSignUp";

const SignupFlow = () => {
  const options = [
    {
      id: "student",
      title: "For Students",
      description: "Find the right tutors for your academic goals.",
      icon: "🎓",
    },
    {
      id: "tutor",
      title: "For Tutors",
      description: "Connect with students and start earning.",
      icon: "📘",
    },
  ];

  type Role = "student" | "tutor";

  const [selected, setSelected] = useState<Role | null>(null);
  const [confirmed, setConfirmed] = useState(false);

  return (
    <AuthLayout
      title="Student Signup"
      route="signup"
      heading="Where Learning Meets Teaching"
      desc="Use our customized tutoring services to arrange in-person or online classes with the best tutors in the country."
    >
      <div className="md:w-8/12 w-11/12 mx-auto overflow-y-scroll">
        <div className="mx-auto">
          {!confirmed && (
            <div>
              <h3 className="text-gray900 text-txs W2STMedium">
                Create an account
              </h3>
              <p className="text-gray700 mb-[20px]">
                Select preferred account type
              </p>
            </div>
          )}

          {confirmed ? (
            // <>
            //   <div>
            <motion.div
              key={selected}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 30 }}
              className="md:mt-10 text-xl font-medium gap-4"
            >
              <div>
                <motion.button
                  onClick={() => setConfirmed(false)}
                  className="py-3 rounded-md text-sm font-medium"
                >
                  ← Back
                </motion.button>
              </div>
              {selected === "student" && <StudentSignUpForm />}
              {selected === "tutor" && <TutorSignUpForm />}
            </motion.div>
          ) : (
            <>
              <div className="space-y-4 w-full">
                {options.map((opt) => (
                  <motion.div
                    key={opt.id}
                    animate={{
                      borderColor: selected === opt.id ? "#7c3aed" : "#e5e7eb",
                      backgroundColor: selected === opt.id ? "#f5f3ff" : "#fff",
                    }}
                    onClick={() => setSelected(opt.id as Role)}
                    className={`flex items-center gap-4 cursor-pointer border-2 rounded-xl p-4 transition-colors`}
                  >
                    <div className="w-12 h-12 bg-indigo-100 flex items-center justify-center rounded-md text-2xl">
                      {opt.icon}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg W2STMedium text-gray-900">
                        {opt.title}
                      </h3>
                      <p className="text-sm text-gray-500">{opt.description}</p>
                    </div>
                    <div className="w-5 h-5 border-2 rounded-full flex items-center justify-center">
                      {selected === opt.id && (
                        <motion.div
                          layoutId="check"
                          className="w-3 h-3 bg-indigo-500 rounded-full"
                        />
                      )}
                    </div>
                  </motion.div>
                ))}
              </div>

              <button
                onClick={() => setConfirmed(true)}
                disabled={!selected}
                className={`block W2STMedium text-center mt-4 py-5 w-full rounded-md text-white text-md transition
        ${
          selected
            ? "bg-indigo-500 hover:bg-indigo-600"
            : "bg-indigo-200 cursor-not-allowed"
        }`}
              >
                Let’s get started
              </button>
            </>
          )}
          <div className="block">
            {/* <button
              className={`block text-center mt-4 py-5 w-full mb-4 rounded-md text-white text-md ${
                isFormValid ? "bg-primary500" : "bg-primary200"
              }`}
              disabled={!isFormValid}
              onClick={handleSubmit}
            >
              Create account {JSON.stringify(isFormComplete(payload))}
            </button> */}
            {/* <Button
              label="Create Account"
              isFormValid={isFormComplete(payload)}
              isLoading={isLoading}
              handleSubmit={handleSubmit}
            /> */}
          </div>
          <p className="mt-10 text-gray500">
            By continuing, you agree to the{" "}
            <Link
              to="/terms"
              target="_blank"
              className="text-primary400 underline"
            >
              Terms of use
            </Link>
            ,{" "}
            <Link
              to="/privacy"
              target="_blank"
              className="text-primary400 underline"
            >
              Privacy Policy
            </Link>
            , and Community Standards of Way2sucesstutors.
          </p>
          <div className="text-center mt-10">
            <Link to="/login" className="text-gray500">
              Already have an account?{" "}
              <span className="text-primary700 W2STMedium ">Log in</span>
            </Link>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default SignupFlow;
